module.exports = __webpack_public_path__ + "static/media/profile.d12a0efc.jpg";